import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>> & {
  white?: boolean;
};

const UnlockedIcon = forwardRef<SVGSVGElement, OwnProps>(
  ({ white, ...props }, ref) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      ref={ref}
      {...props}
    >
      <rect
        x="3.5"
        y="8.25024"
        width="9"
        height="7"
        stroke={white ? '#fff' : '#183558'}
      />
      <path
        d="M10 4.75024V5.75024H11V4.75024C11 3.09339 9.65685 1.75024 8 1.75024C6.34315 1.75024 5 3.09339 5 4.75024V8.75024H11V7.75024H6V4.75024C6 3.64567 6.89543 2.75024 8 2.75024C9.10457 2.75024 10 3.64567 10 4.75024Z"
        fill={white ? '#fff' : '#183558'}
      />
      <path
        d="M7 11.7502L9 11.7502"
        stroke={white ? '#fff' : '#183558'}
        strokeLinecap="round"
      />
    </svg>
  )
);

export default UnlockedIcon;
